import SB7SVG from "assets/svg/SB7Outline.svg";
import FleetHome22SVG from "assets/svg/FleetHome22Outline.svg";
import SiemensSVG from "assets/svg/SiemensOutline.svg";

export default function getChargerGraphic(model: string): string {
  switch (model) {
  case "FleetHome22":
    return FleetHome22SVG;
  case "SB7":
    return SB7SVG;
  case "8EM1310-2EJ04-0GA0":
  case "8EM1310-3EJ04-3GA1":
    return SiemensSVG;
  default:
    return FleetHome22SVG;
  }
}
